import './ErrorBoundaryComponent.style.less'
import { ErrorBoundary } from 'react-error-boundary'
import { Button, Result } from 'antd'

function ErrorFallback({ resetErrorBoundary }: any) {
  return (
    <>
      <Result
        status="warning"
        title="There are some problems with your operation. Please contact Fingertip helpdesk"
        extra={[
          <Button
            key={1}
            size="large"
            type="primary"
            onClick={resetErrorBoundary}
          >
            Reset
          </Button>,
        ]}
      />
    </>
  )
}

interface Props {
  children: any
}

function ErrorBoundaryComponent({ children }: Props) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
  )
}

export default ErrorBoundaryComponent
